import { specialDates } from "../data/schedule";

const WEEKDAY_INDEX: Record<string, number> = {
    Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6,
};


export function checkSchedule(now: Date = new Date()): boolean {
    const { dateStr, day, minutesOfDay } = getIsraelParts(now);

    const match = specialDates.find((e) => dateStr >= e.fromDate && dateStr <= e.toDate);

    if (match) {
        if (match.status === "closed") return false;
        if (match.status === "unknown") return false;
        if (match.status === "open") return isRegularHoursOpen(day, minutesOfDay);
        if (match.status === "special_hours" && match.startTime && match.endTime) {
            return (
                minutesOfDay >= timeToMinutes(match.startTime) &&
                minutesOfDay <= timeToMinutes(match.endTime)
            )
        }
    }
    return isRegularHoursOpen(day, minutesOfDay);
}

function timeToMinutes(t: string): number {
    const [h, m] = t.split(':').map(Number);
    return h * 60 + m;
}

/**
 * Reads the given instant as Israel local time, regardless of the server's
 * own timezone (needed since the server may run on Azure in a different zone).
 */
function getIsraelParts(now: Date) {
    const fmt = new Intl.DateTimeFormat('en-US', {
        timeZone: 'Asia/Jerusalem',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
        weekday: 'short',
    });

    const parts: Record<string, string> = {};
    for (const p of fmt.formatToParts(now)) parts[p.type] = p.value;

    const dateStr = `${parts.year}-${parts.month}-${parts.day}`;
    const hour = parseInt(parts.hour, 10) % 24; // midnight can come back as "24"
    const minute = parseInt(parts.minute, 10);
    const day = WEEKDAY_INDEX[parts.weekday];

    return { dateStr, day, minutesOfDay: hour * 60 + minute };
}


/** Regular weekly hours (no holiday/special date in effect). Israel time. */
function isRegularHoursOpen(day: number, minutesOfDay: number): boolean {
    if (day >= 0 && day <= 4) return minutesOfDay >= 9 * 60 && minutesOfDay < 15 * 60; // Sun-Thu
    if (day === 5) return minutesOfDay >= 9 * 60 && minutesOfDay < 12 * 60; // Fri
    return false; // Sat
}
